module.exports = __webpack_public_path__ + "img/31.e98f1e6f.jpg";